import { useTypedSelector } from "../../../store/store";

import styles from "./index.module.scss";

function MainLayout({ children }: React.PropsWithChildren) {
  const { hero_section_background, brand } = useTypedSelector(
    (state) => state.environment,
  );

  return (
    <main className={styles.container}>
      {brand !== "vid" && (
        <div
          style={{ background: `url(${hero_section_background}) center/cover` }}
          className={styles.hero}
        />
      )}

      <section className={styles.content}>{children}</section>
    </main>
  );
}

export default MainLayout;
